/* eslint-disable complexity */
import { cancelBenefit, createBenefit, createBenefitAddress, createBenefitTask, createOrder, searchUseCases, updateBenefit, validateBenefit } from 'app/modules/benefit/benefit-service/benefit-service';
import { claimTransmit, detectRefusal, generateParams, getClaim, saveClaimErrorLog, terminateClaim } from 'app/modules/claim/service/claim-service';
import { RESET_CLAIM } from 'app/modules/claim/service/store/claim-actions';
import { ClaimState } from 'app/modules/claim/service/store/claim-state';
import { loadModalContent, loadPageContent } from 'app/modules/cms/service/cms-service';
import { addBehaviors, removeBehavior, removeBehaviors, startLoading, stopLoading } from 'app/modules/cms/service/store/cms-dispatchs';
import { redirectToLounge } from 'app/modules/externalApp/service/lounge-service';
import { geoLocationPostAction } from 'app/modules/geolocation/service/geolocation-services';
import { gtmEvent, initializeGtmTagSteps } from 'app/modules/gtm/service/gtm.service';
import { gtmStepsMapper } from 'app/modules/gtm/utils/gtm-mappers';
import { NO, YES } from 'app/shared/constants/constants';
import { CoverCode } from 'app/shared/constants/cover-code';
import { ContactDTO } from 'app/shared/model/contactDTO.model';
import { GeolocationPostActionDTO } from 'app/shared/model/geolocationPostActionDTO.model';
import { setSubscriberAddress, setSubscriberMobileNumber, setSubscriberShippingAddress, updateSubscriber } from 'app/shared/reducers/kubrick-management';
import { arraysEqual, fixStreetNumber, getShippingAddress, isEmptyObject, overwriteShippingAddress } from 'app/shared/util/method-util';
import { format } from 'date-fns';
import { stepEngineApi } from '../api/step-engine-api';
import { CustomerEntryName, ModalConstants, PagePart, Step, StepEngineBehaviorsConstants } from '../utils/step-engine-constants';
import { createFirstContact } from './client-service';
import { RESET_STEP_ENGINE } from './store/step-engine-actions';
import isEqual from 'lodash/isEqual';
import {
  addCustomerEntry,
  addGlobalData,
  addPreviousStep,
  clearStepToScroll,
  removeCustomerEntry,
  removeDeclarationGlobalData,
  removeDisabledNextButton,
  removePreviousStep,
  setBackToHome,
  setCover,
  setCoverDisplayName,
  setCurrentStep,
  setDontShowPopupRedirectUrl,
  setLastEditStep,
  setPreviousCover,
  removePreviousCover,
  setReceivedStep,
  setShowErrorModal,
  setShowRatingModal,
  setShowStepAction,
  setStepGroup
} from './store/step-engine-dispatchs';
import { behaviorStepExist, manageModal } from './utils/services-utils';
import { LoungeActionConstants } from 'app/modules/externalApp/utils/lounge-action-constant';

export const unremovedStepsBehaviors = dataKey => {
  switch (dataKey) {
    case PagePart.SIDE_BAR_MOBILE:
      return true;
    default:
      return false;
  }
};

export const resetStepEngine = () => (dispatch, getState) => {
  const { cmsContent, isMobile } = getState().cms;

  Object.keys(cmsContent).map(function (cmsKey) {
    if (!unremovedStepsBehaviors(cmsKey) && cmsContent[cmsKey]?.behaviors) {
      dispatch(removeBehaviors(cmsKey));
    }
  });
  dispatch({ type: RESET_STEP_ENGINE });
  dispatch({ type: RESET_CLAIM });
  dispatch(addGlobalData('mobile', isMobile));
};

// Test du behaviors pour execution de resetStepEngine
export const checkResetStepEngine = (behaviors: any) => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.[StepEngineBehaviorsConstants.RESET_STEP_ENGINE]) {
    dispatch(resetStepEngine());
  }
};

// Test du behaviors pour execution de la création du sinistre
export const findClaim = claimNumber => async dispatch => {
  await dispatch(getClaim(claimNumber));
};

// Ajoute un event gtm suite à une action de navigation Suivant/Précédent
const addGtmEventFromNavigation = (currentSteps, cmsContent, eventAction: string) => dispatch => {
  // Récupération et concaténation des gtmLabel
  const gtmLabels = currentSteps
    .filter(cs => cmsContent[Step[cs]]?.prismic?.gtmLabel)
    .map(cs => cmsContent[Step[cs]]?.prismic?.gtmLabel)
    .join(' & ');
  if (gtmLabels) dispatch(gtmEvent(gtmLabels, eventAction, '0'));
};

export const computeStepEngineDatas = (dataKey: string, dataValue: any, reset?: boolean) => (dispatch, getState) => {
  const { subscriber } = getState().kubrickManagement;
  if ((dataValue !== null && dataValue !== undefined) || reset) {
    switch (dataKey) {
      case Step.CUSTOMER_INFORMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_FIRST_NAME, dataValue.firstName));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_LAST_NAME, dataValue.lastName));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_EMAIL, dataValue.email));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_PHONE, dataValue.phoneNumber));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_CIVILITY, dataValue.civility));
        if (dataValue.adressePostal != null) {
          if (!isEqual(subscriber?.adressePostal, dataValue.adressePostal)) {
            dispatch(setSubscriberAddress(dataValue.adressePostal));
            dispatch(setSubscriberShippingAddress(dataValue.adressePostal));
          }
          if (!isEqual(subscriber.mobileNumber, dataValue.phoneNumber)) {
            dispatch(setSubscriberMobileNumber(dataValue.phoneNumber));
          }
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_CITY, dataValue.adressePostal.city));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_ADDRESS, dataValue.adressePostal.address));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_POSTAL_CODE, dataValue.adressePostal.postalCode));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_STREET_NUMBER, dataValue.adressePostal.streetNumber));
        }
        break;
      }
      case Step.DAMAGED_GOOD_CIRCONSTANCES: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_CIRCONSTANCES, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DAMAGED_GOOD_CIRCONSTANCES));
        }
        break;
      }
      case Step.DAMAGE_OBSERVED_FREE_ENTRY: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DAMAGE_OBSERVED_FREE_ENTRY, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DAMAGE_OBSERVED_FREE_ENTRY));
        }
        break;
      }
      case Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY));
        }
        break;
      }
      case Step.CLAIM_RESULT_FREE_ENTRY: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.CLAIM_RESULT_FREE_ENTRY, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.CLAIM_RESULT_FREE_ENTRY));
        }
        break;
      }
      case Step.JOURNEY_HOME_PAGE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.JOURNEY_ROUTE_SELECTED, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.JOURNEY_ROUTE_SELECTED));
        }
        break;
      }
      case Step.COVER_SELECTION: {
        dispatch(setCover(dataValue?.value));
        dispatch(setCoverDisplayName(dataValue?.label));
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.COVER_CHOICE));
        }
        break;
      }
      case Step.STOLEN_TYPE_SELECTION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.STOLEN_TYPE_CHOICE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.STOLEN_TYPE_CHOICE));
        }
        break;
      }
      case Step.BURGLARY_DEVICE_SELECTION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.LOCATION_TYPE_CHOICE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.LOCATION_TYPE_CHOICE));
        }
        break;
      }
      case Step.DAMAGED_GOOD_DATE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.INCIDENT_DATE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.INCIDENT_DATE));
        }
        break;
      }
      case Step.DAMAGED_GOOD_FAMILY: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_TYPE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DAMAGED_GOOD_TYPE));
        }
        break;
      }
      case Step.DAMAGED_GOOD_CREATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD, -1));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD));
        }
        break;
      }
      case Step.DAMAGED_GOOD_SELECTION: {
        if (!reset) {
          if (Object.keys(dataValue).length > 0) {
            dispatch(addCustomerEntry(CustomerEntryName.OTHER_DAMAGED_GOOD_SELECTION, NO));
            dispatch(addCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD, JSON.stringify(dataValue[0])));
            dispatch(
              addCustomerEntry(CustomerEntryName.BRAND_SELECTED_INSURED_GOOD, String(dataValue[0]?.brand).toUpperCase())
            );
            dispatch(
              addCustomerEntry(CustomerEntryName.MODEL_SELECTED_INSURED_GOOD, String(dataValue[0]?.model).toUpperCase())
            );
            if (dataValue[0]?.purchaseDate) {
              const purchaseDate = new Date(dataValue[0]?.purchaseDate);
              dispatch(addCustomerEntry(CustomerEntryName.PURCHASE_DATE_SELECTED_INSURED_GOOD, format(purchaseDate, "yyyy-MM-dd'T'HH:mm:ss")));
            }
            if ((dataValue[0]?.ifrBrand !== null && dataValue[0]?.ifrBrand !== "")
              && (dataValue[0]?.ifrModel !== null && dataValue[0]?.ifrModel !== "")) {
              dispatch(addCustomerEntry(CustomerEntryName.IS_MATCHED_IFR, YES));
            }
            else {
              dispatch(addCustomerEntry(CustomerEntryName.IS_MATCHED_IFR, NO))
            }
          } else {
            dispatch(addCustomerEntry(CustomerEntryName.OTHER_DAMAGED_GOOD_SELECTION, YES));
          }
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.OTHER_DAMAGED_GOOD_SELECTION));
          dispatch(removeCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD));
          dispatch(removeCustomerEntry(CustomerEntryName.BRAND_SELECTED_INSURED_GOOD));
          dispatch(removeCustomerEntry(CustomerEntryName.MODEL_SELECTED_INSURED_GOOD));
          dispatch(removeCustomerEntry(CustomerEntryName.PURCHASE_DATE_SELECTED_INSURED_GOOD));
          dispatch(removeCustomerEntry(CustomerEntryName.IS_MATCHED_IFR));
        }
        break;
      }
      case Step.DAMAGED_GOOD_IMEI_VALIDATION:
      case Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.IMEI_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.IMEI_CONFIRMATION));
        }
        break;
      }
      case Step.DAMAGED_GOOD_USER_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.USER_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.USER_CONFIRMATION));
        }
        break;
      }
      case Step.EXTERNAL_DAMAGE_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.EXTERNAL_DAMAGE_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.EXTERNAL_DAMAGE_CONFIRMATION));
        }
        break;
      }
      case Step.CLIENT_DETAILS_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.CORDINATES_UPDATE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.CORDINATES_UPDATE));
        }
        break;
      }
      case Step.CLAIM_TRIGGER_NATURE: {
        if (!reset) {
          let stringArray = '';
          if (dataValue instanceof Array) {
            stringArray = dataValue
              .map(item => {
                return item.code;
              })
              .join(',');
          } else {
            stringArray = dataValue.code;
          }
          dispatch(addCustomerEntry(CustomerEntryName.CLAIM_TRIGGER_NATURE, stringArray));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.CLAIM_TRIGGER_NATURE));
        }
        break;
      }
      case Step.CLAIM_RESULT_SELECTION: {
        if (!reset) {
          let stringArray = '';
          if (dataValue instanceof Array) {
            stringArray = dataValue
              .map(item => {
                return item.code;
              })
              .join(',');
          } else {
            stringArray = dataValue.code;
          }
          dispatch(addCustomerEntry(CustomerEntryName.CLAIM_RESULT_SELECTION, stringArray));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.CLAIM_RESULT_SELECTION));
        }
        break;
      }
      case Step.CLAIM_DECLARATION_DATE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.INCIDENT_DATE, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.INCIDENT_DATE));
        }
        break;
      }
      case Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.PROPER_USE_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.PROPER_USE_CONFIRMATION));
        }
        break;
      }
      case Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.PROPER_FUNCTIONING_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.PROPER_FUNCTIONING_CONFIRMATION));
        }
        break;
      }
      case Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION));
        }
        break;
      }
      case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION:
      case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.REPARATION_PERIOD_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.REPARATION_PERIOD_CONFIRMATION));
        }
        break;
      }
      case Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION:
      case Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION_APPLE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.REPLACED_PERIOD_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.REPLACED_PERIOD_CONFIRMATION));
        }
        break;
      }
      case Step.PRODUCT_IN_POCKET_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.POCKET_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.POCKET_CONFIRMATION));
        }
        break;
      }
      case Step.BENEFIT_TYPE_SELECTION:
      case Step.BENEFIT_TYPE_SELECTION_APPLE: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.BENEFIT_TYPE_SELECTION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.BENEFIT_TYPE_SELECTION));
        }
        break;
      }
      case Step.BENEFIT_DEPOSIT_METHOD: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DEPOSIT_METHOD, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DEPOSIT_METHOD));
        }
        break;
      }
      case Step.BENEFIT_POINT_SELECTION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.BENEFIT_POINT_SELECTION, JSON.stringify(dataValue)));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.BENEFIT_POINT_SELECTION));
        }
        break;
      }
      case Step.TRANSPORT_VOUCHER_GENERATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.TRANSPORT_VOUCHER_GENERATION_ACTION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.TRANSPORT_VOUCHER_GENERATION_ACTION));
        }
        break;
      }
      case Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT));
        }
        break;
      }
      case Step.REGISTERED_STATEMENT: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.REGISTERED_STATEMENT, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.REGISTERED_STATEMENT));
        }
        break;
      }
      case Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION_ACTION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION_ACTION));
        }
        break;
      }
      case Step.REFERENTIAL_ITEMS: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.IS_RIGHT_GOOD, dataValue));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.IS_RIGHT_GOOD));
        }
        break;
      }
      case Step.COMPLAINED_TO_MERCHANT_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.COMPLAINED_TO_MERCHANT_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.COMPLAINED_TO_MERCHANT_CONFIRMATION));
        }
        break;
      }
      case Step.THEFT_INSURED_PERSON_ELIGIBILITY: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.THEFT_INSURED_PERSON_ELIGIBILITY, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.THEFT_INSURED_PERSON_ELIGIBILITY));
        }
        break;
      }
      case Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.CAPITAL_ADDRESS, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.CAPITAL_ADDRESS));
        }
        break;
      }
      case Step.THEFT_ACCESSORIES_VALIDATION:
      case Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.ACCESSORIES_VALIDATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.ACCESSORIES_VALIDATION));
        }
        break;
      }
      case Step.DAMAGED_GOOD_ACCESSORIES_SELECTION: {
        if (!reset) {
          if (dataValue instanceof Array) {
            let purchasePrice = 0;
            let stringArray = '';
            stringArray = dataValue
              .map(item => {
                purchasePrice += parseFloat(item?.value)
                return item?.code;
              })
              .join(',');
            dispatch(addCustomerEntry(CustomerEntryName.ACCESSORIES_SELECTION, stringArray));
            dispatch(addCustomerEntry(CustomerEntryName.ACCESSORIES_PURCHASE_PRICE, purchasePrice));
          }
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.ACCESSORIES_SELECTION));
          dispatch(removeCustomerEntry(CustomerEntryName.ACCESSORIES_PURCHASE_PRICE));
        }
        break;
      }
      case Step.RECOVERY_METHOD: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.RECOVERY_METHOD, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.RECOVERY_METHOD));
        }
        break;
      }
      case Step.COMPLAINED_TO_POLICE_CONFIRMATION: {
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.COMPLAINED_TO_POLICE_CONFIRMATION, dataValue?.value));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.COMPLAINED_TO_POLICE_CONFIRMATION));
        }
        break;
      }
      case Step.DEVICE_PATTERN_LOCK:
        if (!reset) {
          dispatch(addCustomerEntry(CustomerEntryName.DEVICE_PATTERN_LOCK, JSON.stringify(dataValue)));
        } else {
          dispatch(removeCustomerEntry(CustomerEntryName.DEVICE_PATTERN_LOCK));
        }
        break;
      default:
        break;
    }
  }
};

export const getPreviousStep = () => (dispatch, getState) => {
  const { previousSteps, stepData, globalData } = getState().stepEngine;
  const { cmsContent, isMobile } = getState().cms;
  const { currentSteps } = stepData;

  if (behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.DEPOSIT_METHOD)) {
    dispatch(removeBehavior(Step[currentSteps[0]], StepEngineBehaviorsConstants.DEPOSIT_METHOD));
  }

  if (behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP)) {
    dispatch(setCurrentStep(cmsContent[Step[currentSteps[0]]]?.behaviors?.goToPreviousStep));
    dispatch(removeBehavior(Step[currentSteps[0]], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP));
  } else {
    if (Object.keys(previousSteps).length > 0) {
      const previousStep = previousSteps[currentSteps.join(',')];
      if (previousStep.includes('GET_FIRST_STEP')) {
        dispatch(setBackToHome(true));
      } else {
        currentSteps.forEach(currentStep => {
          if (Step[previousStep] === Step.COVER_SELECTION || Step[currentStep] === Step.COVER_SELECTION) {
            dispatch(setCover(null));
          }
        });
        if (cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover) {
          dispatch(removePreviousCover());
          dispatch(setCover(cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover));

          const coverObject = {
            ...globalData[Step.COVER_SELECTION],
            code: CoverCode[cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover],
            value: cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover,
          };
          dispatch(addGlobalData(Step.COVER_SELECTION, coverObject));
          dispatch(addBehaviors(Step[currentSteps[currentSteps.length - 1]], { previousStep: null }));
        }
        if (previousStep) {
          // GTM Action Précédent
          dispatch(addGtmEventFromNavigation(currentSteps, cmsContent, 'Précédent'));
          // Set the new current step and update the view
          currentSteps.forEach(currentStep => {
            dispatch(removeDeclarationGlobalData(Step[currentStep]));
            dispatch(computeStepEngineDatas(Step[currentStep], null, true));
            dispatch(removeDisabledNextButton(currentStep));
          });
          if (isMobile) {
            dispatch(removePreviousStep(currentSteps[0]));
          }
          dispatch(setCurrentStep(previousStep));
          return true;
        }
      }
      return false;
    }
  }
};

export const loadStepsDatas = (steps: any[], globalData, cmsContent, behaviors) => async (dispatch, getState) => {
  // On boucle sur les steps renvoyés par le moteur d'étape
  for (const step of steps) {
    // Si on retrouve des réponses du nouvel écran dans le globalData et que l'on a pas de behavior DONT_RELOAD_DATA
    // on raffraichi le declarationGlobalData et les customerEntry à partir de ces données
    if (globalData[Step[step]] && (isEmptyObject(behaviors) || !behaviors[StepEngineBehaviorsConstants.DONT_RELOAD_DATA])) {
      await dispatch(computeStepEngineDatas(Step[step], globalData[Step[step]]));
      await dispatch(addGlobalData(Step[step], globalData[Step[step]]));
      await dispatch(setLastEditStep(Step[step]));
    }
    // Si le contenu prismic n'est pas encore en session on le charge
    if (!cmsContent[Step[step]]) {
      await dispatch(loadPageContent(Step[step]));
    }
  }
};

// Test du behaviors pour execution de la détection des refus
export const checkRefusals = (step: any, globalData, cmsContent, previousSteps) => async dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.DETECT_REFUSAL)) {
    await dispatch(detectRefusal(globalData, cmsContent, previousSteps));
  }
};

// Test du behaviors pour création d'un contact
export const createContactFirstStep = (step: any, globalData, cmsContent, isMobileChannel) => async dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CREATE_FIRST_CONTACT)) {
    const contactDTO = new ContactDTO(null, globalData?.clientNumber, globalData?.subscriptionNumber, isMobileChannel);
    await dispatch(createFirstContact(contactDTO));
  }
};

// Test du behaviors pour execution de la création du sinistre
export const checkCreateClaim = (step: any, declarationGlobalData, cmsContent, previousSteps) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.SAVE_DECLARATION)) {
    await dispatch(claimTransmit(declarationGlobalData, cmsContent, previousSteps));
  }
};

// Test du globalDta pour execution de l'annulation de La prestation
export const checkExistingBenefit = (step: any, cmsContent) => async (dispatch, getState) => {
  const { stepData } = getState().stepEngine;
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CHECK_EXISTING_BENEFIT) && stepData?.createdBenefitId) {
    await dispatch(cancelBenefit(stepData?.createdBenefitId));
  }
};

// Test du behaviors pour execution de la création du order
export const checkCreateOrder = (step: any, cmsContent) => async (dispatch, getState) => {
  const { subscriberSherpa } = getState().kubrickManagement;
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CREATE_ORDER)) {
    await dispatch(createOrder(subscriberSherpa));
  }
};

// Test du behaviors pour execution de la création du benefit
export const checkCreateBenefit = (step: any, cmsContent) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CREATE_BENEFIT)) {
    const { orderId } = getState().order.data;
    const { declarationGlobalData, previousSteps } = getState().stepEngine;
    const params = generateParams(declarationGlobalData, cmsContent, previousSteps);
    await dispatch(createBenefit(params, orderId));
  }
};

// Test du behaviors pour execution de la recherche des types de prestation possible
export const checkSearchUseCases = (step: any, cmsContent) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.SEARCH_USE_CASES)) {
    const { declarationGlobalData, previousSteps } = getState().stepEngine;
    const params = generateParams(declarationGlobalData, cmsContent, previousSteps);
    await dispatch(searchUseCases(params));
  }
};

// @typescript-eslint/no-unnecessary-type-assertion
// Test du behaviors pour execution de la création du benefit
export const checkUpdateBenefit = (step: any, cmsContent) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.UPDATE_BENEFIT)) {
    const { declarationGlobalData, previousSteps, stepData } = getState().stepEngine;
    const { subscription } = getState().kubrickManagement;

    const params = generateParams(declarationGlobalData, cmsContent, previousSteps);
    await dispatch(updateBenefit(stepData?.createdBenefitId, {
      globalData: params,
      subscription
    }));
  }
};

export const checkOverwriteClientShippingAddressBehaviors = (behaviors) => (dispatch, getState) => {
  const { subscriber } = getState().kubrickManagement;
  if (!isEmptyObject(behaviors) && behaviors?.overwriteClientShippingAddress) {
    subscriber.shippingAddress = overwriteShippingAddress(subscriber)
  }
};

const getBenefitPointSelectionAddress = (subscriber: any, benefitPointSelection: any) => {
  subscriber.shippingAddress = getShippingAddress(subscriber);
  const pointShippingAddress = fixStreetNumber({ ...benefitPointSelection });
  return {
    ...subscriber.shippingAddress,
    streetNumber: pointShippingAddress.streetNumber,
    address: pointShippingAddress.address,
    additionalAddress: pointShippingAddress.additionalAddress,
    city: pointShippingAddress.city,
    zipCode: pointShippingAddress.zipCode?.slice(0, 5)
  }
}

// Test du behaviors pour execution de l'update de L'adress de Shipping
export const checkUpdateClientAddress = (step: any, cmsContent) => async (dispatch, getState) => {
  const { subscriber } = getState().kubrickManagement;
  const { declarationGlobalData } = getState().stepEngine;

  if (
    behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.UPDATE_CLIENT_ADDRESS)
    ||
    behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.UPDATE_CLIENT_SHIPPING_ADDRESS)
  ) {
    if (!isEmptyObject(declarationGlobalData[Step.BENEFIT_POINT_SELECTION])) {
      subscriber.shippingAddress = getBenefitPointSelectionAddress(subscriber, declarationGlobalData[Step.BENEFIT_POINT_SELECTION]);
    }
    await updateSubscriber(subscriber, dispatch);
  }
};

const checkCreateBenefitAddress = (step: any, cmsContent) => async (dispatch, getState) => {
  const { subscriber } = getState().kubrickManagement;
  const { declarationGlobalData, stepData } = getState().stepEngine;

  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CREATE_BENEFIT_ADDRESS)) {
    const isEmpty = isEmptyObject(declarationGlobalData[Step.BENEFIT_POINT_SELECTION]);
    await dispatch(createBenefitAddress(subscriber, stepData?.createdBenefitId, isEmpty));
  }
};


const checkTerminateClaim = (step: any, cmsContent) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.TERMINATE_CLAIM)) {
  const { globalData, stepData } = getState().stepEngine;
  const { benefitId, claimNumber } = getState().claim;
  if (globalData && claimNumber) {
    await dispatch(terminateClaim(step, cmsContent, globalData, claimNumber, benefitId));
  }
}
};


// Test du behaviors pour execution de l'appel de API FeedBack
export const checkShowRatingModal = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.SHOW_RATING_MODAL]) {
    await dispatch(setShowRatingModal(true));
  }
};

// Test du behaviors pour valider la prestation
export const checkValidateBenefit = (behaviors) => async (dispatch, getState) => {
  const { benefitId } = getState().claim;
  if (!isEmptyObject(behaviors) && behaviors?.validateBenefit && benefitId) {
    await dispatch(validateBenefit(benefitId));
  }
};

export const checkCreateBenefitTask = (behaviors, cmsContent) => async (dispatch, getState) => {
  const { claimNumber } = getState().claim;
  const { declarationGlobalData, previousSteps } = getState().stepEngine;
  const params = generateParams(declarationGlobalData, cmsContent, previousSteps);


  if (!isEmptyObject(behaviors) && behaviors?.createBenefitTask) {
    await dispatch(createBenefitTask(claimNumber, params));
  }
};

export const checkDontShowPopupRedirectUrl = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.dontShowPopupRedirectUrl) {
    await dispatch(setDontShowPopupRedirectUrl(behaviors?.dontShowPopupRedirectUrl));
  }
};

export const checkStepGroup = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.stepGroup) {
    await dispatch(setStepGroup(behaviors?.stepGroup));
  }
};

export const checkShowStepAction = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.showStepAction) {
    await dispatch(setShowStepAction(behaviors?.showStepAction));
  }
};

// Test du behaviors cover
export const checkCoverBehaviors = (step: any, globalData, cmsContent, behaviors) => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.COVER]) {
    const coverBehavior = behaviors[StepEngineBehaviorsConstants.COVER];

    if (behaviors[StepEngineBehaviorsConstants.PREVIOUS_COVER]) {
      await dispatch(setPreviousCover(behaviors[StepEngineBehaviorsConstants.PREVIOUS_COVER]));
    } else {
      await dispatch(removePreviousCover());
    }

    await dispatch(setCover(coverBehavior));

    const coverCode = CoverCode[coverBehavior];
    const coverLabel = cmsContent[Step.COVER_SELECTION]?.prismic.items
      .find(item => item.code === coverCode)
      ?.label;

    const coverObject = {
      ...globalData[Step.COVER_SELECTION],
      code: coverCode,
      value: coverBehavior,
      label: coverLabel ?? globalData[Step.COVER_SELECTION]?.label
    };
    await dispatch(addGlobalData(Step.COVER_SELECTION, coverObject));
  }
};


export const checkJourneyDataBehaviors = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.journeyData) {
    for (const key of Object.keys(behaviors.journeyData.customerEntry)) {
      await dispatch(addCustomerEntry(CustomerEntryName[key], behaviors.journeyData.customerEntry[key]));
    }

    await dispatch(setCover(behaviors.journeyData.cover));
  }
};

// Test du behaviors InitDamagedGoods
export const checkInitDamagedGoodsBehaviors = (behaviors, insuredGoods) => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.INIT_DAMAGED_GOODS]) {
    await dispatch(addGlobalData(Step.DAMAGED_GOOD_SELECTION, insuredGoods));
  }
};

// Test du behaviors provokeBackward
export const checkNoBackwardBehaviors = (newSteps: string[], newPreviousSteps: string[], cmsContent) => dispatch => {
  if (
    !(newSteps.length === newPreviousSteps.length && arraysEqual(newSteps, newPreviousSteps)) &&
    !behaviorStepExist(cmsContent, newSteps[0], StepEngineBehaviorsConstants.PROVOKE_BACKWARD)
  ) {
    dispatch(addPreviousStep(newSteps, newPreviousSteps));
  }
};

// Test du behaviors
export const checkDepositMethodBehaviors = (step: any, cmsContent) => dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.DEPOSIT_METHOD)) {
    dispatch(removeBehavior(Step[step], StepEngineBehaviorsConstants.DEPOSIT_METHOD));
  }
};

// Test du behaviors geoLocationPostAction
export const checkGeoLocationPostActionBehaviors = behaviors => async (dispatch, getState) => {
  const { claimNumber } = getState().claim;
  const { subscription } = getState().kubrickManagement;
  const { stepData } = getState().stepEngine;
  const { isMobile } = getState().cms;
  if (!isEmptyObject(behaviors) && behaviors?.geoLocationPostAction) {
    const geolocationPostActionDTO: GeolocationPostActionDTO = {
      type: behaviors.geoLocationPostAction,
      claimNumber,
      subscriptionNumber: subscription?.subscriptionNumber,
      clientNumber: subscription?.subscriber?.number,
      currentStep: stepData.currentSteps[0],
      url: location.href + '/' + stepData.currentSteps[0] + '/' + subscription?.subscriptionNumber + '/' + claimNumber,
      mobile: isMobile
    };

    await dispatch(geoLocationPostAction(geolocationPostActionDTO));
  }
};

// Test du behaviors
export const checkBackToHomeBehaviors = behaviors => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.backToHome) {
    dispatch(setBackToHome(true));
  }
};

// Test du behaviors RedirectToLounge
export const checkRedirectToLoungeBehaviors = (behaviors: any) => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.[StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE]) {
    dispatch(redirectToLounge(behaviors.redirectToLounge));
  }
};

// Ajoute une previsousStep depuis le behaviors (Pour accéder à une étape sur laquelle on ne serait pas passé depuis le récap via le crayon)
export const addPreviousStepFromBehaviors = behaviors => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.ADD_PREVIOUS_STEP]) {
    dispatch(
      addPreviousStep(
        [behaviors[StepEngineBehaviorsConstants.ADD_PREVIOUS_STEP].split(';')[0]],
        [behaviors[StepEngineBehaviorsConstants.ADD_PREVIOUS_STEP].split(';')[1]]
      )
    );
  }
};

// Initialise la liste des steps/réponses à tagger dans GTM
export const checkGtmTagStepsBehaviors = behaviors => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.gtmTagSteps) {
    dispatch(initializeGtmTagSteps(behaviors.gtmTagSteps));
  }
};

// GTM : On tag step/reponse dans GTM si question dans gtmTagSteps et label/reponse dans mappers
export const addGtmTagSteps = (currentSteps: string[], globalData, gtmTagSteps: string[], cmsContent) => dispatch => {
  for (const step of currentSteps) {
    const event = gtmStepsMapper(step, globalData);
    const gtmLabelStep = cmsContent[Step[step]]?.prismic?.gtmLabel;
    if (gtmTagSteps.includes(step) && gtmLabelStep !== undefined && event !== undefined) {
      dispatch(gtmEvent(gtmLabelStep, event, '0'));
    }
  }
};

export const getNextStep = () => async (dispatch, getState) => {
  let { stepData } = getState().stepEngine;
  const { globalData, declarationGlobalData, previousSteps, stepToScroll } = getState().stepEngine;
  const { gtmTagSteps } = getState().gtm;
  const { cmsContent, isMobile } = getState().cms;
  const currentSteps: any[] = stepData.currentSteps;
  try {
    dispatch(startLoading());
    if (!isMobile) {
      // Skeleton : Attribut pour afficher le skeleton : skeleton standart
      await dispatch(setReceivedStep(null));
    }
    // GTM  : Action Suivant
    dispatch(addGtmEventFromNavigation(currentSteps, cmsContent, 'Suivant'));
    // GTM : check gtmTagSteps et mappers puis tag label/réponse dans GTM
    dispatch(addGtmTagSteps(currentSteps, declarationGlobalData, gtmTagSteps, cmsContent));

    // Si on a un behaviors 'goToPreviousStep' sur la page courante, on redirige vers sa valeur, puis on le supprime de la step
    // le moteur d'étape ne sera pas appelé
    if (
      behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP)
      &&
      !behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_NEXT_STEP)
    ) {
      const stepBehaviors = cmsContent[Step[currentSteps[0]]]?.behaviors;
      await dispatch(removeBehaviors(Step[currentSteps[0]]));
      await dispatch(setCurrentStep(stepBehaviors?.goToPreviousStep));
    } else {
      await dispatch(createContactFirstStep(currentSteps[0], globalData, cmsContent, isMobile));
      await dispatch(checkRefusals(currentSteps[0], globalData, cmsContent, previousSteps));
      await dispatch(checkUpdateClientAddress(currentSteps[0], cmsContent)); // Ensure to update the address before creating the claim, as the new shipping address will be used in the recap mail.
      await dispatch(checkCreateClaim(currentSteps[0], declarationGlobalData, cmsContent, previousSteps));
      await dispatch(checkCreateBenefitAddress(currentSteps[0], cmsContent));// Create claim and update client address for retrieve good benefit assignement 
      await dispatch(checkSearchUseCases(currentSteps[0], cmsContent));// Recherche des types de prestation qui peuvent être proposé au client
      await dispatch(checkExistingBenefit(currentSteps[0], cmsContent));
      await dispatch(checkCreateOrder(currentSteps[0], cmsContent))
      await dispatch(checkCreateBenefit(currentSteps[0], cmsContent));
      await dispatch(checkUpdateBenefit(currentSteps[0], cmsContent));
      await dispatch(checkTerminateClaim(currentSteps[0], cmsContent));
      // Recharger le stepData depuis le reducer
      stepData = getState().stepEngine?.stepData;
      // Appel au moteur d'étape pour récupérer les prochaines steps
      const response = await stepEngineApi.nextStep(stepData);

      if (response?.status === 200 || response?.status === 201) {
        const { data } = response || {};
        if (data) {
          const { steps, behaviors } = data || {};
          await dispatch(checkValidateBenefit(behaviors));
          await dispatch(checkCreateBenefitTask(behaviors, cmsContent));
          if (steps) {
            if (stepToScroll) {
              dispatch(clearStepToScroll());
            }
            await dispatch(checkShowRatingModal(behaviors));
            // Chargement des données des steps (declarartionGlobalData/customerEntry/prismic)
            await dispatch(checkResetStepEngine(behaviors));
            // Attribut pour afficher le skeleton : skeleton spécifique
            await dispatch(setReceivedStep(steps));

            // GTM : Initialisation des steps qu'on souhaite taggé dans GTM (question/réponse)
            await dispatch(checkGtmTagStepsBehaviors(behaviors));
            // On initialise les éléments sinistrés avec les éléments assurés de l'adhésion
            await dispatch(checkInitDamagedGoodsBehaviors(behaviors, stepData.subscriptionDto.insuredGoods));
            // Chargement des données des steps (declarartionGlobalData/customerEntry/prismic)
            await dispatch(loadStepsDatas(steps, globalData, cmsContent, behaviors));

            // ??? Si on trouve un behaviors 'depositMethod', on le supprime
            await dispatch(checkDepositMethodBehaviors(Step[currentSteps[0]], cmsContent));

            // Si on ne reçoit pas le behaviors 'provokeBackward', on ajoute les steps courantes dans PreviousStep
            await dispatch(checkNoBackwardBehaviors(steps, currentSteps, cmsContent));

            await dispatch(checkDontShowPopupRedirectUrl(behaviors));
            await dispatch(checkStepGroup(behaviors));
            await dispatch(checkShowStepAction(behaviors));
            await dispatch(checkOverwriteClientShippingAddressBehaviors(behaviors));

            if (!isEmptyObject(behaviors)) {
              // On stocke les behaviors renvoyés par le moteur d'étape dans le store
              for (const step of steps) {
                await dispatch(addBehaviors(Step[step], behaviors));
              }
            } else {
              await dispatch(setShowStepAction(true));
            }

            // On met à jour les currentSteps
            await dispatch(setCurrentStep(steps));

            // Si on a reçu le behaviors cover, on ajoute la customerEntry et on modifie la cover avec cette valeur
            await dispatch(checkCoverBehaviors(Step[steps[0]], globalData, cmsContent, behaviors));
            await dispatch(checkJourneyDataBehaviors(behaviors));
            await dispatch(manageModal(cmsContent, behaviors));

            await dispatch(checkBackToHomeBehaviors(behaviors));

            // Si on recoit le behaviors addPreviousStep on ajoute le previousStep
            await dispatch(addPreviousStepFromBehaviors(behaviors));
            await dispatch(checkGeoLocationPostActionBehaviors(behaviors));
          } else {
            // await dispatch(setShowStepAction(true));
            // Si on recoit le behaviors RedirectToLoungeBehaviors
            await dispatch(checkGeoLocationPostActionBehaviors(behaviors));
            await dispatch(checkRedirectToLoungeBehaviors(behaviors));
          }
        }
      }
    }
    dispatch(stopLoading());
  } catch (err) {
    if (err !== null && err !== undefined) { dispatch(saveClaimErrorLog(err?.toString())); }
    dispatch(stopLoading());
    throw err;
  }
};

export const getSpecificStepFromEvent = (param: any) => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    await dispatch(findClaim(param.claimNumber));
    const claim: ClaimState = getState().claim;
    dispatch(addCustomerEntry(CustomerEntryName.FROM_SPECIFIC_STEP, '1'));
    dispatch(addCustomerEntry(CustomerEntryName.CLAIM_NUMBER, param.claimNumber));
    dispatch(setCurrentStep([param.stepName]));
    dispatch(stopLoading());
    await dispatch(getNextStep());
  } catch (error) {
    dispatch(stopLoading());
    location.replace('/');
    throw error;
  }
};
export const getSpecificStep = specificStep => async (dispatch, getState) => {
  const { cmsContent } = getState().cms;
  try {
    dispatch(startLoading());

    const response = await stepEngineApi.specificStep(specificStep);

    if (response.status === 200 || response.status === 201) {
      if (response.data?.steps) {
        const { steps, behaviors } = response.data;

        dispatch(setCurrentStep(steps));
        steps.map(step => {
          if (!cmsContent[Step[step]]) {
            dispatch(loadPageContent(Step[step]));
          }
        });
        if (behaviors && Object.keys(behaviors).length > 0) {
          const { showStepAction, showModal, cover } = behaviors;

          steps.map(step => {
            dispatch(addBehaviors(Step[step], behaviors));
            if (!showStepAction) {
              dispatch(setShowStepAction(showStepAction));
            } else dispatch(setShowStepAction(true));
          });
          if (showModal) {
            if (!cmsContent[ModalConstants[showModal]]) {
              dispatch(loadModalContent(ModalConstants[showModal]));
            }
            dispatch(setShowErrorModal(true));
          }
          if (cover === 'OXIDATION') {
            dispatch(setCover(cover));
          }
        }
      }
    } else {
      // No response from the backend
    }
  } catch (error) {
    dispatch(stopLoading());
    location.replace('/');
    throw error;
  }
};

export const getSpecificStepBehaviors = (specificStepName, deviceType) => async dispatch => {
  try {
    dispatch(startLoading());

    // Appel au moteur d'étape pour récupérer les behaviors de step
    const response = await stepEngineApi.specificStep({ requestStep: specificStepName, deviceType });
    if (response?.status === 200 || response?.status === 201) {
      if (response?.data?.behaviors) {
        const { behaviors } = response.data || {};
        if (behaviors && Object.keys(behaviors).length > 0) {
          await dispatch(addBehaviors(Step[specificStepName], behaviors));
        }
      }
    }
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    throw error;
  }
};

export const hidePreviousButton = (cmsContent, currentStep: string) => {
  return behaviorStepExist(cmsContent, currentStep, StepEngineBehaviorsConstants.HIDE_PREVIOUS_BUTTON);
};

export const hideNextButton = (cmsContent, currentStep: string) => {
  return behaviorStepExist(cmsContent, currentStep, StepEngineBehaviorsConstants.HIDE_NEXT_BUTTON);
};